export const mockFactories = [
  {
    id: "techvision",
    name: "TechVision Factory",
    tagline: "Premium Electronics Direct from the Source",
    avatar: "https://public.readdy.ai/ai/img_res/ca575757e520388faabdf63268b41900.jpg",
    banner: "https://readdy.ai/api/search-image?query=modern%20electronics%20factory%20interior%20clean%20production%20line%20technology%20manufacturing%20professional%20wide%20shot&width=1200&height=400&seq=fbanner1&orientation=landscape",
    verified: true,
    rating: 4.9,
    totalReviews: 8420,
    totalSales: 42300,
    memberSince: "2023-01",
    location: "Austin, TX, USA",
    category: "Electronics",
    responseTime: "< 2 hours",
    fulfillmentRate: "99.2%",
    founded: "2018",
    employees: "250-500",
    annualRevenue: "$12M+",
    moq: "$8,000",
    leadTime: "7-14 days",
    exportCountries: ["USA", "Canada", "UK", "Germany", "Australia", "Japan"],
    certifications: [
      { name: "ISO 9001:2015", issuer: "Bureau Veritas", year: "2022", icon: "ri-award-line", color: "bg-green-50 text-green-700 border-green-200" },
      { name: "CE Certified", issuer: "TÜV Rheinland", year: "2023", icon: "ri-shield-check-line", color: "bg-green-50 text-green-700 border-green-200" },
      { name: "FCC Approved", issuer: "FCC USA", year: "2023", icon: "ri-government-line", color: "bg-green-50 text-green-700 border-green-200" },
      { name: "RoHS Compliant", issuer: "SGS Group", year: "2022", icon: "ri-leaf-line", color: "bg-green-50 text-green-700 border-green-200" },
      { name: "UL Listed", issuer: "Underwriters Lab", year: "2023", icon: "ri-fire-line", color: "bg-orange-50 text-orange-700 border-orange-200" },
    ],
    warehouses: [
      { type: "local", label: "Local Warehouse", location: "Austin, TX", shippingTime: "2-4 business days", flag: "🇺🇸" },
      { type: "overseas", label: "Overseas Warehouse", location: "Shenzhen, China", shippingTime: "7-14 business days", flag: "🇨🇳" },
    ],
    about: "TechVision Factory is a vertically integrated electronics manufacturer based in Austin, TX. We design, manufacture, and ship premium consumer electronics directly to buyers — cutting out the middleman and passing savings to you. All products carry our Verified Factory guarantee.",
    products: [
      {
        id: "1",
        title: "Premium Wireless Earbuds Pro X200",
        price: 49.99,
        originalPrice: 89.99,
        image: "https://readdy.ai/api/search-image?query=premium%20wireless%20earbuds%20white%20clean%20product%20photography%20on%20white%20background%20minimalist%20studio%20lighting&width=400&height=400&seq=prod1&orientation=squarish",
        rating: 4.8,
        reviews: 2341,
        commission: 12,
        badge: "Best Seller",
        stock: 500,
        warehouse: ["local", "overseas"],
        category: "Audio",
        moq: 100,
      },
      {
        id: "6",
        title: "Portable Bluetooth Speaker IPX7",
        price: 39.99,
        originalPrice: 69.99,
        image: "https://readdy.ai/api/search-image?query=portable%20bluetooth%20speaker%20cylindrical%20black%20waterproof%20clean%20white%20background%20product%20photography&width=400&height=400&seq=prod6&orientation=squarish",
        rating: 4.7,
        reviews: 2089,
        commission: 10,
        badge: "Flash Sale",
        stock: 450,
        warehouse: ["local"],
        category: "Audio",
        moq: 50,
      },
      {
        id: "3",
        title: "Smart LED Desk Lamp with USB-C",
        price: 28.99,
        originalPrice: 45.00,
        image: "https://readdy.ai/api/search-image?query=modern%20smart%20LED%20desk%20lamp%20white%20minimalist%20design%20clean%20white%20background%20product%20photography%20studio&width=400&height=400&seq=prod3&orientation=squarish",
        rating: 4.7,
        reviews: 987,
        commission: 8,
        badge: "New Arrival",
        stock: 800,
        warehouse: ["local", "overseas"],
        category: "Lighting",
        moq: 200,
      },
      {
        id: "tv4",
        title: "4K Action Camera Waterproof 60fps",
        price: 79.99,
        originalPrice: 129.99,
        image: "https://readdy.ai/api/search-image?query=4K%20action%20camera%20compact%20waterproof%20black%20clean%20white%20background%20product%20photography%20studio%20minimal&width=400&height=400&seq=prodtv4&orientation=squarish",
        rating: 4.6,
        reviews: 1204,
        commission: 11,
        badge: "Hot Deal",
        stock: 320,
        warehouse: ["local", "overseas"],
        category: "Cameras",
        moq: 50,
      },
      {
        id: "tv5",
        title: "USB-C 65W GaN Fast Charger",
        price: 24.99,
        originalPrice: 39.99,
        image: "https://readdy.ai/api/search-image?query=USB-C%20GaN%20fast%20charger%20compact%20white%20clean%20product%20photography%20white%20background%20minimal%20studio&width=400&height=400&seq=prodtv5&orientation=squarish",
        rating: 4.9,
        reviews: 3876,
        commission: 9,
        badge: "Top Rated",
        stock: 2000,
        warehouse: ["local"],
        category: "Accessories",
        moq: 500,
      },
      {
        id: "tv6",
        title: "Smart Home Hub WiFi 6 Router",
        price: 89.99,
        originalPrice: 149.99,
        image: "https://readdy.ai/api/search-image?query=smart%20home%20wifi%20router%20white%20modern%20minimal%20clean%20product%20photography%20white%20background%20studio&width=400&height=400&seq=prodtv6&orientation=squarish",
        rating: 4.7,
        reviews: 654,
        commission: 13,
        badge: "New",
        stock: 180,
        warehouse: ["local", "overseas"],
        category: "Networking",
        moq: 30,
      },
    ],
    reviews: [
      { id: "fr1", user: "Marcus J.", avatar: "https://readdy.ai/api/search-image?query=young%20black%20man%20portrait%20casual%20smile%20natural%20light%20headshot&width=40&height=40&seq=frev1&orientation=squarish", rating: 5, comment: "Incredible quality and super fast shipping from Austin. Will definitely order again!", date: "2026-04-05" },
      { id: "fr2", user: "Priya S.", avatar: "https://readdy.ai/api/search-image?query=indian%20woman%20portrait%20professional%20headshot%20warm%20smile&width=40&height=40&seq=frev2&orientation=squarish", rating: 5, comment: "Verified factory badge gives me so much confidence. Products are exactly as described.", date: "2026-03-28" },
      { id: "fr3", user: "Tyler B.", avatar: "https://readdy.ai/api/search-image?query=athletic%20man%20portrait%20gym%20background%20confident%20smile%20casual&width=40&height=40&seq=frev3&orientation=squarish", rating: 4, comment: "Great products, responsive seller. The overseas warehouse option saved me a lot on bulk orders.", date: "2026-03-15" },
    ],
  },
  {
    id: "pureglow",
    name: "PureGlow Labs",
    tagline: "Science-Backed Beauty, Factory Direct",
    avatar: "https://readdy.ai/api/search-image?query=beauty%20skincare%20brand%20logo%20pink%20circle%20icon%20clean%20minimal%20professional&width=80&height=80&seq=fav2&orientation=squarish",
    banner: "https://readdy.ai/api/search-image?query=modern%20beauty%20cosmetics%20laboratory%20clean%20white%20interior%20skincare%20production%20professional%20wide%20shot&width=1200&height=400&seq=fbanner2&orientation=landscape",
    verified: true,
    rating: 4.9,
    totalReviews: 12800,
    totalSales: 68900,
    memberSince: "2022-08",
    location: "Los Angeles, CA, USA",
    category: "Beauty",
    responseTime: "< 1 hour",
    fulfillmentRate: "99.8%",
    founded: "2019",
    employees: "100-250",
    annualRevenue: "$8M+",
    moq: "$5,000",
    leadTime: "5-10 days",
    exportCountries: ["USA", "Canada", "UK", "France", "South Korea", "Singapore"],
    certifications: [
      { name: "FDA Registered", issuer: "US FDA", year: "2022", icon: "ri-government-line", color: "bg-green-50 text-green-700 border-green-200" },
      { name: "Cruelty-Free", issuer: "Leaping Bunny", year: "2021", icon: "ri-heart-line", color: "bg-rose-50 text-rose-700 border-rose-200" },
      { name: "ISO 22716", issuer: "SGS Group", year: "2023", icon: "ri-award-line", color: "bg-green-50 text-green-700 border-green-200" },
      { name: "GMP Certified", issuer: "NSF International", year: "2022", icon: "ri-shield-check-line", color: "bg-green-50 text-green-700 border-green-200" },
    ],
    warehouses: [
      { type: "local", label: "Local Warehouse", location: "Los Angeles, CA", shippingTime: "1-3 business days", flag: "🇺🇸" },
      { type: "overseas", label: "Overseas Warehouse", location: "Seoul, South Korea", shippingTime: "5-10 business days", flag: "🇰🇷" },
    ],
    about: "PureGlow Labs is a certified cosmetics manufacturer based in Los Angeles. Our formulations are dermatologist-tested, cruelty-free, and made with premium ingredients sourced globally. We sell factory-direct to ensure freshness and authenticity.",
    products: [
      {
        id: "4",
        title: "Vitamin C Brightening Serum 30ml",
        price: 19.99,
        originalPrice: 38.00,
        image: "https://readdy.ai/api/search-image?query=vitamin%20C%20brightening%20serum%20glass%20bottle%20skincare%20product%20clean%20white%20background%20minimalist%20photography&width=400&height=400&seq=prod4&orientation=squarish",
        rating: 4.9,
        reviews: 3210,
        commission: 15,
        badge: "Top Rated",
        stock: 2000,
        warehouse: ["local", "overseas"],
        category: "Serums",
        moq: 200,
      },
      {
        id: "pg2",
        title: "Hyaluronic Acid Moisturizer 50ml",
        price: 24.99,
        originalPrice: 44.00,
        image: "https://readdy.ai/api/search-image?query=hyaluronic%20acid%20moisturizer%20cream%20jar%20white%20clean%20skincare%20product%20photography%20white%20background%20minimal&width=400&height=400&seq=prodpg2&orientation=squarish",
        rating: 4.8,
        reviews: 2100,
        commission: 14,
        badge: "Best Seller",
        stock: 1500,
        warehouse: ["local", "overseas"],
        category: "Moisturizers",
        moq: 150,
      },
      {
        id: "pg3",
        title: "Retinol Night Repair Cream 30ml",
        price: 29.99,
        originalPrice: 55.00,
        image: "https://readdy.ai/api/search-image?query=retinol%20night%20cream%20luxury%20skincare%20tube%20packaging%20clean%20white%20background%20product%20photography%20minimal&width=400&height=400&seq=prodpg3&orientation=squarish",
        rating: 4.7,
        reviews: 1450,
        commission: 16,
        badge: "New Arrival",
        stock: 800,
        warehouse: ["local"],
        category: "Anti-Aging",
        moq: 100,
      },
      {
        id: "pg4",
        title: "SPF 50 Sunscreen Fluid 60ml",
        price: 14.99,
        originalPrice: 26.00,
        image: "https://readdy.ai/api/search-image?query=SPF%20sunscreen%20fluid%20bottle%20white%20clean%20skincare%20product%20photography%20white%20background%20minimal%20studio&width=400&height=400&seq=prodpg4&orientation=squarish",
        rating: 4.8,
        reviews: 2890,
        commission: 12,
        badge: "Popular",
        stock: 3000,
        warehouse: ["local", "overseas"],
        category: "Sun Care",
        moq: 300,
      },
    ],
    reviews: [
      { id: "fr4", user: "Aisha W.", avatar: "https://readdy.ai/api/search-image?query=young%20black%20woman%20portrait%20professional%20smile%20natural%20light&width=40&height=40&seq=frev4&orientation=squarish", rating: 5, comment: "Best serum I've ever used. Love that it comes straight from the lab — so fresh!", date: "2026-04-08" },
      { id: "fr5", user: "Emma R.", avatar: "https://readdy.ai/api/search-image?query=latina%20woman%20portrait%20bright%20smile%20natural%20light%20casual%20headshot&width=40&height=40&seq=frev5&orientation=squarish", rating: 5, comment: "The commission rate is amazing for influencers. My followers love this product too!", date: "2026-03-22" },
    ],
  },
  {
    id: "fitforge",
    name: "FitForge Manufacturing",
    tagline: "Professional Fitness Gear, Built to Last",
    avatar: "https://readdy.ai/api/search-image?query=fitness%20dumbbell%20brand%20logo%20red%20circle%20icon%20clean%20minimal%20professional&width=80&height=80&seq=fav3&orientation=squarish",
    banner: "https://readdy.ai/api/search-image?query=modern%20fitness%20equipment%20factory%20warehouse%20interior%20professional%20wide%20shot%20gym%20products%20manufacturing&width=1200&height=400&seq=fbanner3&orientation=landscape",
    verified: true,
    rating: 4.7,
    totalReviews: 9100,
    totalSales: 31200,
    memberSince: "2023-03",
    location: "Denver, CO, USA",
    category: "Sports & Fitness",
    responseTime: "< 3 hours",
    fulfillmentRate: "98.5%",
    founded: "2020",
    employees: "50-100",
    annualRevenue: "$5M+",
    moq: "$8,000",
    leadTime: "10-21 days",
    exportCountries: ["USA", "Canada", "Australia", "Germany", "Brazil"],
    certifications: [
      { name: "ISO 9001:2015", issuer: "Bureau Veritas", year: "2023", icon: "ri-award-line", color: "bg-green-50 text-green-700 border-green-200" },
      { name: "ASTM Compliant", issuer: "ASTM International", year: "2022", icon: "ri-shield-check-line", color: "bg-green-50 text-green-700 border-green-200" },
      { name: "CPSC Certified", issuer: "US CPSC", year: "2023", icon: "ri-government-line", color: "bg-green-50 text-green-700 border-green-200" },
    ],
    warehouses: [
      { type: "local", label: "Local Warehouse", location: "Denver, CO", shippingTime: "3-5 business days", flag: "🇺🇸" },
      { type: "overseas", label: "Overseas Warehouse", location: "Guangzhou, China", shippingTime: "8-15 business days", flag: "🇨🇳" },
    ],
    about: "FitForge Manufacturing produces professional-grade fitness equipment for gyms, athletes, and home users. Based in Denver, CO, we manufacture everything in-house with strict quality control. Our products are used by over 500 gyms across the USA.",
    products: [
      {
        id: "8",
        title: "Resistance Bands Set 5-Level",
        price: 16.99,
        originalPrice: 29.99,
        image: "https://readdy.ai/api/search-image?query=resistance%20bands%20set%20colorful%20five%20levels%20fitness%20exercise%20clean%20white%20background%20product%20photography&width=400&height=400&seq=prod8&orientation=squarish",
        rating: 4.6,
        reviews: 4521,
        commission: 8,
        badge: "Hot Deal",
        stock: 5000,
        warehouse: ["local", "overseas"],
        category: "Resistance Training",
        moq: 500,
      },
      {
        id: "5",
        title: "Stainless Steel Water Bottle 32oz",
        price: 22.99,
        originalPrice: 35.00,
        image: "https://readdy.ai/api/search-image?query=stainless%20steel%20insulated%20water%20bottle%20matte%20black%20clean%20white%20background%20product%20photography%20studio&width=400&height=400&seq=prod5&orientation=squarish",
        rating: 4.5,
        reviews: 1567,
        commission: 7,
        badge: "Popular",
        stock: 3000,
        warehouse: ["local"],
        category: "Accessories",
        moq: 200,
      },
      {
        id: "ff3",
        title: "Adjustable Dumbbell Set 5-52.5 lbs",
        price: 189.99,
        originalPrice: 299.99,
        image: "https://readdy.ai/api/search-image?query=adjustable%20dumbbell%20set%20black%20modern%20fitness%20equipment%20clean%20white%20background%20product%20photography%20studio&width=400&height=400&seq=prodff3&orientation=squarish",
        rating: 4.8,
        reviews: 892,
        commission: 10,
        badge: "Premium",
        stock: 200,
        warehouse: ["local"],
        category: "Free Weights",
        moq: 20,
      },
      {
        id: "ff4",
        title: "Yoga Mat Non-Slip 6mm Premium",
        price: 34.99,
        originalPrice: 59.99,
        image: "https://readdy.ai/api/search-image?query=premium%20yoga%20mat%20rolled%20up%20teal%20green%20clean%20white%20background%20product%20photography%20minimal%20studio&width=400&height=400&seq=prodff4&orientation=squarish",
        rating: 4.7,
        reviews: 2340,
        commission: 9,
        badge: "Best Seller",
        stock: 1500,
        warehouse: ["local", "overseas"],
        category: "Yoga",
        moq: 100,
      },
    ],
    reviews: [
      { id: "fr6", user: "James P.", avatar: "https://readdy.ai/api/search-image?query=young%20asian%20man%20portrait%20casual%20smile%20natural%20light%20headshot&width=40&height=40&seq=frev6&orientation=squarish", rating: 5, comment: "Ordered 4 sets for my home gym. Quality is insane for the price. Fast shipping from Denver!", date: "2026-04-12" },
      { id: "fr7", user: "Carlos R.", avatar: "https://readdy.ai/api/search-image?query=hispanic%20man%20portrait%20professional%20confident%20smile%20casual%20background&width=40&height=40&seq=frev7&orientation=squarish", rating: 4, comment: "Great factory, very responsive. The overseas warehouse option is perfect for bulk orders.", date: "2026-03-30" },
    ],
  },
];

export const mockFactoryNotifications = [
  {
    id: "notif1",
    type: "factory_viewed",
    factoryName: "TechVision Factory",
    factoryAvatar: "https://readdy.ai/api/search-image?query=modern%20tech%20company%20logo%20icon%20professional%20blue%20circle%20clean%20minimal&width=80&height=80&seq=fav1&orientation=squarish",
    factoryLocation: "Austin, TX, USA",
    factoryVerified: true,
    requirementTitle: "500 Units Wireless Earbuds OEM",
    requirementId: "req1",
    viewedAt: "2026-04-12T09:32:00Z",
    isRead: false,
    message: "TechVision Factory viewed your requirement and may send a quotation soon.",
  },
  {
    id: "notif2",
    type: "quote_received",
    factoryName: "PureGlow Labs",
    factoryAvatar: "https://readdy.ai/api/search-image?query=beauty%20skincare%20brand%20logo%20pink%20circle%20icon%20clean%20minimal%20professional&width=80&height=80&seq=fav2&orientation=squarish",
    factoryLocation: "Los Angeles, CA, USA",
    factoryVerified: true,
    requirementTitle: "1,000 Units Vitamin C Serum Private Label",
    requirementId: "req2",
    viewedAt: "2026-04-11T14:15:00Z",
    isRead: false,
    message: "PureGlow Labs sent you a quotation for your requirement. Check your email.",
  },
  {
    id: "notif3",
    type: "factory_viewed",
    factoryName: "FitForge Manufacturing",
    factoryAvatar: "https://readdy.ai/api/search-image?query=fitness%20dumbbell%20brand%20logo%20red%20circle%20icon%20clean%20minimal%20professional&width=80&height=80&seq=fav3&orientation=squarish",
    factoryLocation: "Denver, CO, USA",
    factoryVerified: true,
    requirementTitle: "2,000 Resistance Bands Bulk Order",
    requirementId: "req3",
    viewedAt: "2026-04-10T11:05:00Z",
    isRead: true,
    message: "FitForge Manufacturing viewed your requirement and may send a quotation soon.",
  },
  {
    id: "notif4",
    type: "quote_received",
    factoryName: "TechVision Factory",
    factoryAvatar: "https://readdy.ai/api/search-image?query=modern%20tech%20company%20logo%20icon%20professional%20blue%20circle%20clean%20minimal&width=80&height=80&seq=fav1&orientation=squarish",
    factoryLocation: "Austin, TX, USA",
    factoryVerified: true,
    requirementTitle: "500 Units Wireless Earbuds OEM",
    requirementId: "req1",
    viewedAt: "2026-04-12T16:45:00Z",
    isRead: false,
    message: "TechVision Factory sent you a competitive quotation. Review it now.",
  },
];
